module.exports = __webpack_public_path__ + "img/reload-img.8942b949.png";